declare var $

export class GravityForm {

	el: HTMLElement

  constructor(el) {
		this.el = el
    this.init()
  }

  init() {
    this.updateFilled()
    $(this.el)
      .on('change', 'input, select, textarea', () => {
        this.updateFilled()
      })
  }

  updateFilled() {
    $('.gfield', this.el).each((i, el) => {
      const input = $('input, select, textarea', el)
      if (input.val() !== '') {
        $(el).addClass('filled')
      } else {
        $(el).removeClass('filled')
      }
    })

  }

}